
import { useNavigate, useParams } from "react-router-dom";
import { DisenioCentroCosto } from "../../layout";
import { BuscadorSoloValor, CargandoMedio } from "../../components";
import { useConsumoCentrosCosto } from "../../../hooks";
import { TablaCentroCostosConsumo, TablaTotalConsumoCentros } from "../../components/facturas";

import Swal from "sweetalert2";




export const EntradasCentroCosto = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { data, isLoading, termino, chageTermino, chagePage, page } = useConsumoCentrosCosto(id);

    
    // const handleNavegar = (url) => {
    //     navigate(`/admin/cencos/${id}/${url}`)
    // }

    // const handleEliminarInfo = async() => {
    //     const result = await Swal.fire({
    //         title: 'Eliminar Producto',
    //         text: '¿Está seguro de eliminar este producto?',
    //         icon: 'question',
    //         showCancelButton: true,
    //         confirmButtonText: 'Sí, eliminar',
    //         cancelButtonText: 'Cancelar'
    //     });
        
    //     if (!result.isConfirmed) return;
        
    //     await mutationDeleteProducto.mutateAsync(id);
    // }




    return (

        <DisenioCentroCosto titulo="Entradas de Centro de Costo" url={1}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando consumos de centro de costo..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} titulo='Buscar consumo...' place='Buscar x producto...'/>
                <TablaTotalConsumoCentros />
                <TablaCentroCostosConsumo data={data || []} chagePage={chagePage} page={page} />
                </>
            }
            
        </DisenioCentroCosto>

    )
}
